<template>
    <div class="content content-fixed content-auth">
        <div class="container">
            <div class="media align-items-stretch justify-content-center ht-100p pos-relative">
                <div class="media-body align-items-center d-none d-lg-flex">
                    <div class="mx-wd-600">
                        <img src="../../assets/img/1.png" class="img-fluid" alt="">
                    </div>

                </div><!-- media-body -->
                <div class="sign-wrapper mg-lg-l-50 mg-xl-l-60">
                    <div class="wd-100p">
                        <h3 class="tx-color-01 mg-b-5">Acknowledge</h3>
                        <p class="tx-color-03 tx-16 mg-b-40">Welcome back! <br> Please acknowledge your appointment to continue.</p>
                        <officer-reg-form></officer-reg-form>
                        <div class="divider-text">or</div>
                        <div class="tx-13 mg-t-20 tx-center">Don't have an account? <router-link to="/register">Create an Account</router-link></div>
                    </div>
                </div><!-- sign-wrapper -->
            </div><!-- media -->
        </div><!-- container -->
    </div><!-- content -->
</template>

<script>
    import OfficerRegForm from "../../components/form/OfficerRegForm";
    // import NewAccountButton from "../../components/button/NewAccountButton";
    import {mapState} from "vuex"
    export default {
        name: "Logon",
        components:{
            OfficerRegForm,
            //NewAccountButton
        },
        computed:{
            ...mapState([
                'system'
            ]),
        },
        mounted() {
            console.log('authLoading>>> ', this.system.appLoading)
        }
    }
</script>

<style scoped>

</style>